import {AdvancedMarker} from '@vis.gl/react-google-maps';

const MomentMarker = ({ moment, isSelected, onSelectMoment }) => {
  // Skip rendering if moment doesn't exist or has no location
  if (!moment || !moment.latitude || !moment.longitude) {
    return null;
  }
  
  return (
    <AdvancedMarker 
      position={{lat: moment.latitude, lng: moment.longitude}}
      onClick={() => onSelectMoment(moment)}
    >
      <div className="marker" style={{
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        backgroundColor: isSelected ? '#FF0000' : '#0000FF',
        border: '2px solid #FFFFFF',
        cursor: 'pointer',
        boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
      }} />
    </AdvancedMarker>
  );
};

export default MomentMarker;